<template>
  <!-- 关于 -->
  <div id="about">
    <span class="unified-module-title">关于金界</span>
    <p style="color:rgb(120,120,120);text-align:center;">金界让人工智能无处不在</p>
    <div class="company-profile">
      <div class="profile">
        <div class="fl">
          <img src="../assets/ab.jpg" alt>
        </div>
        <div class="fr" v-html="contInfo.info.content">
          {{contInfo.info.content}}
          <!-- <p>广州市金界电子设备有限公司十八年专注计算机与校园领域的研发，是校园智慧互联网、物联网、校园大数据、云计算、校园人工智能等解决方案及其产品制造集成服务商，系统产品遍及校园安全管理、师生健康、智能校园、智慧教室，深入现代学校、未来学校的探究，把校园万物智能互联，让校园人工智能无处不在，方案浸透校园的每一项目。有自主专利知识产权及著作权，有十八年产品使用效果及质量验证。系统产品突显安全、实用、标准、经济，具先进前瞻性，切实解决学校实际需求。专研创新教育装备走在行业的前列，系统产品适合全国大专中小学及幼儿园示范应用。促进学校教育现代化，信息智慧化。</p>
          <p>近年，公司继续走进未来学校教育装备的研究，深挖开发更多为学校教育走向领航者的系统产品，携手学校合作伙伴与时俱进。</p> -->
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
#about {
  width: 100%;
  height: 100%;
  margin-top: 50px;
  text-align: center;
}
.company-profile {
  width: 1200px;
  height: 400px;
  margin: 30px auto;
}
.profile {
  /* width: 900px; */
  width: 100%;
  height: 400px;
  float: left;
}
.fl {
  width: 305px;
  float: left;
  margin-top: 18px;
}
.fr {
  /* width: 595px; */
  width:800px;
  float: right;
  padding: 0px 0px 0px 15px;
  box-sizing: border-box;
  margin-right: 50px;
}
.fr >>> p {
  text-indent: 2em;
  word-wrap: break-word;
  word-break: break-all;
  text-align: left;
  margin-top: 8px;
}
span {
  text-align: left !important;
}
.news {
  width: 295px;
  height: 400px;
  /* border: 1px solid black; */
  float: right;
  text-align: left;
  box-sizing: border-box;
  padding: 0 10px 10px 10px;
}
.news-title {
  display: inline-block;
}
.more-news {
  float: right;
  /* margin-right:5px; */
}
</style>
<script>
export default {
  name: "about",
  data() {
    return {
      contInfo: {
        info: {
          content: "<p>关于金界</p>"
        }
      }
    };
  },
  mounted() {
    var self = this;
    $.ajax({
      url: "/aboutmanage.php",
      type: "get",
      data: null,
      headers: {
        "Content-Type": "application/json"
      },
      success: function(data, textStatus, jqXHR) {
        var data = JSON.parse(data)[0];
        data.info = JSON.parse(data.info);
        console.log(data);
        self.contInfo = data;
        
      },
      error(jqXHR, status, errormsg) {}
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/components/about.vue